import type { ThemeConfig } from "antd";

const defaultTheme: ThemeConfig = {
  token: {
    colorPrimary: "#D61456",
    fontSize: 15,
    fontFamily: "Vazir",
  },
  components: {
    Button: {
      borderRadiusLG: 90,
      contentFontSizeLG: 20,
      paddingBlockLG: 21,
    },
    Typography: {
      titleMarginBottom: 0,
    },
  },
};
export default defaultTheme;
